import React from "react";
import styles from "./OnboardingInfoLoadingSkeleton.module.scss";

const OnboardingInfoLoadingSkeleton = () => {
  return (
    <div className={styles.headerLoadingSkeleton}>
      <div>
        <div className={styles.headerLoadingText} />
      </div>
    </div>
  );
};

export default OnboardingInfoLoadingSkeleton;
